<template>
  <div :style="{ width: width }">
    <div ref="myEchart" :class="className" :style="{ height: height, width: '100%' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts/map/js/china'; // 引入全国地图数据

export default {
  name: 'ChinaMap',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    mapData: {
      type: Array,
      required: true
    },
    visualMapPieces: {
      type: Array,
      default() {
        return [
          { gt: 100, label: '> 100 次', color: '#3c82e1' },
          { gte: 50, lte: 100, label: '50 - 100次', color: '#27e1e6' },
          { gte: 20, lt: 50, label: '10 - 50 次', color: '#e1783c' },
          { gt: 0, lt: 20, label: '1 - 10 次', color: '#e6e622' },
          { value: 0, label: '无扫码', color: '#3ce15a' }
        ];
      }
    },
    showVisualMap: {
      type: Boolean,
      default: true
    },
    titleText: {
      type: String,
      default: '全国产品扫码热度图'
    },
    tooltipName: {
      type: String,
      default: '扫码次数'
    },
    tooltipUnit: {
      type: String,
      default: '次'
    }
  },
  data() {
    return {
      chart: null,
      mapname: 'china' // 全国地图固定为 china
    };
  },
  watch: {
    mapData: {
      handler() {
        this.$nextTick(() => {
          this.updateChart();
        });
      },
      deep: true
    },
    visualMapPieces: {
      handler() {
        this.$nextTick(() => {
          this.updateChart();
        });
      },
      deep: true
    },
    showVisualMap() {
      this.$nextTick(() => {
        this.updateChart();
      });
    },
    titleText() {
      this.$nextTick(() => {
        this.updateChart();
      });
    }
  },
  mounted() {
    this.initChart();
    this.setupResizeListener();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.myEchart);
      this.updateChart();
    },

    updateChart() {
      if (!this.chart) return;
      if (!this.mapData || this.mapData.length === 0) {
        console.warn('[ChinaMap] mapData 为空，跳过渲染');
        return;
      }

      for (let i = 0; i < this.mapData.length; i++) {
        const obj = this.mapData[i];
        if (obj.name) {
          obj.name = obj.name.substring(0, 2);
        }
        switch (obj.name) {
          case "内蒙":
            obj.name = "内蒙古";
            break;
          case "黑龙":
            obj.name = "黑龙江";
            break;
          case "南海":
            obj.name = "南海诸岛";
            break;
          default:
            break;
        }
      }
      const option = {
        backgroundColor: 'transparent',
        title: {
          show: true,
          text: this.titleText,
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal',
            color: '#333'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.name}<br/>${this.tooltipName}: ${params.value || 0} ${this.tooltipUnit}`;
          }
        },
        series: [
          {
            name: this.tooltipName,
            type: 'map',
            map: this.mapname,
            roam: false,
            zoom: 1.2,
            label: {
              normal: {
                show: true,
                fontSize: 11,
                color: '#333'
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#99d0ec',
                borderWidth: 0.8
              },
              emphasis: {
                areaColor: '#fe9b7d'
              }
            },
            data: this.mapData
          }
        ]
      };

      if (this.showVisualMap) {
        option.visualMap = {
          type: 'piecewise',
          pieces: this.visualMapPieces,
          right: 26,
          bottom: 40,
          showLabel: true,
          text: ['高', '低'],
          show: true,
          orient: 'vertical',
          itemWidth: 14,
          itemHeight: 14,
          textStyle: {
            fontSize: 12,
            color: '#666'
          },
          dimension: 0
        };
      }

      this.chart.setOption(option, false);
    },

    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    },

    setupResizeListener() {
      if (this.autoResize) {
        window.addEventListener('resize', this.resizeChart);
      }
    }
  },
  beforeDestroy() {
    if (this.chart) {
      window.removeEventListener('resize', this.resizeChart);
      this.chart.dispose();
      this.chart = null;
    }
  }
};
</script>

<style scoped>
.chart {
  width: 100%;
}
</style>